import { combineReducers } from 'redux'

import authReducer from './components/Auth/redux/authReducer'
import collectionData from './common/redux/collectionReducer'
import dataAnalytics from './components/DataAnalytics/redux/dataAnalyticsReducer'
import loading from './common/redux/loadingReducer'
import feedbackReducer from './common/redux/feedbackReducer'

export default combineReducers({
  authReducer,
  collectionData,
  dataAnalytics,
  loading,
  feedbackReducer,
})
